import { AnnotationEngine } from '@/features/annotation'

export function setupShadowDomSelectionHandler(
  shadowRoot: ShadowRoot,
  engine: AnnotationEngine
): () => void {
  const contentWrapper = shadowRoot.querySelector('.content-wrapper')
  if (!contentWrapper) {
    return () => {}
  }

  const handleSelectionEvent = () => {
    const localSelection = (shadowRoot as any).getSelection?.() as
      | Selection
      | undefined
    const selection =
      localSelection && localSelection.rangeCount > 0
        ? localSelection
        : globalThis.getSelection()

    if (!selection || selection.rangeCount === 0 || selection.isCollapsed) {
      return
    }

    const range = selection.getRangeAt(0)
    if (!contentWrapper.contains(range.commonAncestorContainer)) {
      return
    }

    const text = selection.toString()
    if (!text.trim()) {
      return
    }

    const metadata = engine.get(range)
    if (!metadata) {
      return
    }

    const event = new CustomEvent('annotation-selection', {
      detail: { metadata },
      bubbles: true,
      composed: true,
    })

    shadowRoot.host.dispatchEvent(event)
  }

  const handleMouseDown = () => {
    const localSelection = (shadowRoot as any).getSelection?.() as
      | Selection
      | undefined
    const selection =
      localSelection && localSelection.rangeCount > 0
        ? localSelection
        : globalThis.getSelection()

    if (selection && !selection.isCollapsed) {
      selection.removeAllRanges()

      const event = new CustomEvent('annotation-selection-cleared', {
        bubbles: true,
        composed: true,
      })

      shadowRoot.host.dispatchEvent(event)
    }
  }

  contentWrapper.addEventListener(
    'mouseup',
    handleSelectionEvent as EventListener
  )
  contentWrapper.addEventListener(
    'keyup',
    handleSelectionEvent as EventListener
  )
  contentWrapper.addEventListener('mousedown', handleMouseDown as EventListener)

  return () => {
    contentWrapper.removeEventListener(
      'mouseup',
      handleSelectionEvent as EventListener
    )
    contentWrapper.removeEventListener(
      'keyup',
      handleSelectionEvent as EventListener
    )
    contentWrapper.removeEventListener(
      'mousedown',
      handleMouseDown as EventListener
    )
  }
}
